import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./menu_item_view_details_style.js";
//#region src/menu_item_view_details_style_helper.ts
var menu_item_view_details_style_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(style) {
	switch (style) {
		case "default": return "Default";
		case "compact": return "Compact";
	}
}
//#endregion
export { menu_item_view_details_style_helper_exports, name };

//# sourceMappingURL=menu_item_view_details_style_helper.js.map